import { useParams } from "react-router-dom";
import AdminNewDash from "../admin/NewDash";

/** Magic link: vista Validation Score (veredicto 4 barras). */
export default function MagicValidationScoreDash() {
  const { token } = useParams<{ token: string }>();
  if (!token) return null;
  return <AdminNewDash magicToken={token} />;
}
